import React from 'react'

import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Modal } from 'Components/atoms'
import routes from 'Config/routes'

import {
  Container,
  Content,
  Title,
  SubTitle,
  RowButtonSection,
  CancelButton,
  NotServedButton,
  CloseButton,
} from './styled'

const NotServedInfo = ({
  showModal,
  setShowModal,
  width,
  height,
  onConfirm,
  onCancelOrder,
  canCancelOrder,
  hideOpenNC,
  disableCancelOrder,
}) => {
  const { t } = useTranslation()
  const history = useHistory()

  const onClose = () => {
    setShowModal(false)
    history.push(routes.historic)
  }

  return (
    <Modal
      isOpen={showModal}
      setIsOpen={setShowModal}
      width={width}
      height={height}
      onClose={onClose}
      disableOutsideClick={!!hideOpenNC}
    >
      <Container>
        <Content>
          <Title>{t('errorReception0')}</Title>
          {!hideOpenNC && <SubTitle>{canCancelOrder ? t('errorReceptionWhy') : t('errorReception0Msg')}</SubTitle>}
          {hideOpenNC && <SubTitle>{t('errorReception0MsgNothingToDo')}</SubTitle>}

          <RowButtonSection showCancelOrder={canCancelOrder}>
            {canCancelOrder && !hideOpenNC && (
              <CancelButton onClick={disableCancelOrder ? undefined : onCancelOrder} disabled={disableCancelOrder}>
                {t('askCancelOrder')}
              </CancelButton>
            )}

            {!hideOpenNC && (
              <NotServedButton showCancelOrder={canCancelOrder} onClick={onConfirm}>
                {canCancelOrder ? t('notServidedOrder') : t('openNoCompliance')}
              </NotServedButton>
            )}
          </RowButtonSection>
          {hideOpenNC && (
            <CloseButton
              onClick={() => {
                setShowModal(false)
                history.push(routes.historic)
              }}
            >
              {t('close')}
            </CloseButton>
          )}
        </Content>
      </Container>
    </Modal>
  )
}

export default NotServedInfo

NotServedInfo.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancelOrder: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  canCancelOrder: PropTypes.bool,
  hideOpenNC: PropTypes.bool,
  disableCancelOrder: PropTypes.bool,
}

NotServedInfo.defaultProps = {
  showModal: false,
  setShowModal: () => {},
  onConfirm: () => {},
  onCancelOrder: () => {},
  width: '',
  height: '',
  canCancelOrder: false,
  hideOpenNC: false,
  disableCancelOrder: false,
}
